import useNotificationContext from './useNotificationContext';

const useNotification = () => {
    const { showNotification } = useNotificationContext();

    const notificationSuccess = (message, duration = 5000) => {
        showNotification(message, 'success', duration);
    };
    const notificationError = (message, duration = 5000) => {
        showNotification(message, 'error', duration);
    };
    const notificationWarning = (message, duration = 5000) => {
        showNotification(message, 'warning', duration);
    };
    const notificationInfo = (message, duration = 5000) => {
        showNotification(message, 'info', duration);
    };

    return {
        notificationSuccess,
        notificationError,
        notificationWarning,
        notificationInfo
    };
};

export default useNotification;
